import React from 'react'
import bgImg from 'assets/img/clientbg.png'
import clientImg from 'assets/img/clientImg.png'
import { useNavigate } from 'react-router-dom'

function Client() {
  const navigate = useNavigate()

  const toSignUp = () => {
    navigate('/auth/register')
  }

  return (
    <div
      className="flex flex-col sm:flex-row justify-center items-center gap-[19px] relative w-full h-auto py-[65px] rounded-[17px] bg-[#021B4E]"
      // style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className="flex flex-col items-start w-[323px] h-[241px] sm:w-[412px] sm:h-[351px]">
        <div className="flex items-start sm:justify-center sm:items-center gap-[7.303px] sm:gap-[9.32px] px-[27.8px] py-[3.65px] sm:px-[35.417px] sm:py-[4.66px] rounded-[24.101px] sm:rounded-[30.757px] border-[0.932px] border-white border-b-[#11378F] mb-[9px] sm:mb-[19px]">
          <p className="text-white text-center font-manrope text-[14.606px] sm:text-[18.64px] font-light leading-normal not-italic">
            Looking to Hire?
          </p>
        </div>
        <div className="w-[323px] sm:w-[412px] mb-[9px] sm:mb-[19px]">
          <p className="text-white font-manrope text-4xl not-italic font-light leading-normal">
            Why{' '}
            <span className="text-[#FFC628] font-medium">settle for words</span>{' '}
            alone?{' '}
            <span className="absolute mt-0 sm:mt-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="46"
                viewBox="0 0 37 46"
                fill="none"
              >
                <path
                  d="M17.9645 27.9155C18.1099 28.0534 18.2735 28.1213 18.4359 28.1267C18.44 28.1267 18.4447 28.1287 18.4495 28.1287C18.6145 28.1308 18.7776 28.0649 18.9175 27.9345L25.7874 22.5705L27.4583 21.2432V14.569C27.4583 14.5656 27.461 14.5629 27.461 14.5595V7.4009V5.37063V4.98753C27.461 4.91961 27.4814 4.85373 27.5188 4.79803C27.5269 4.75252 27.5453 4.71041 27.5555 4.6649C27.5833 4.53991 27.6145 4.41697 27.658 4.2981C27.6764 4.24716 27.6988 4.19826 27.7205 4.14799C27.7694 4.03048 27.8237 3.91705 27.8876 3.80701C27.9161 3.75743 27.9467 3.70987 27.9773 3.66233C28.0438 3.56044 28.1151 3.46399 28.1926 3.37025C28.232 3.32338 28.2707 3.2772 28.3121 3.23236C28.3923 3.14678 28.4772 3.06799 28.5669 2.99192C28.5988 2.96407 28.6259 2.93078 28.6585 2.9043H11.9097C10.5499 2.9043 9.44336 4.01079 9.44336 5.37063V21.2446L10.844 22.3579L17.9645 27.9155ZM19.1573 6.1864H25.0212C25.2093 6.1864 25.3608 6.33856 25.3608 6.52602C25.3608 6.71349 25.2093 6.86564 25.0212 6.86564H19.1573C18.9691 6.86564 18.8176 6.71349 18.8176 6.52602C18.8176 6.33856 18.9691 6.1864 19.1573 6.1864ZM19.1573 9.02769H25.0212C25.2093 9.02769 25.3608 9.17984 25.3608 9.36731C25.3608 9.55479 25.2093 9.70694 25.0212 9.70694H19.1573C18.9691 9.70694 18.8176 9.55479 18.8176 9.36731C18.8176 9.17984 18.9691 9.02769 19.1573 9.02769ZM19.1573 11.8696H25.0212C25.2093 11.8696 25.3608 12.0211 25.3608 12.2093C25.3608 12.3967 25.2093 12.5489 25.0212 12.5489H19.1573C18.9691 12.5489 18.8176 12.3967 18.8176 12.2093C18.8176 12.0211 18.9691 11.8696 19.1573 11.8696ZM11.6366 6.68157C11.6366 6.14633 12.0714 5.71161 12.6073 5.71161H15.6646C16.2005 5.71161 16.6352 6.14633 16.6352 6.68157V10.681C16.6352 11.2162 16.2005 11.6509 15.6646 11.6509H12.6073C12.0714 11.6509 11.6366 11.2162 11.6366 10.681V6.68157ZM11.9023 14.7109H25.0212C25.2093 14.7109 25.3608 14.8624 25.3608 15.0506C25.3608 15.238 25.2093 15.3902 25.0212 15.3902H11.9023C11.7148 15.3902 11.5626 15.238 11.5626 15.0506C11.5626 14.8624 11.7148 14.7109 11.9023 14.7109ZM11.9023 17.5522H25.0212C25.2093 17.5522 25.3608 17.7044 25.3608 17.8918C25.3608 18.0793 25.2093 18.2315 25.0212 18.2315H11.9023C11.7148 18.2315 11.5626 18.0793 11.5626 17.8918C11.5626 17.7044 11.7148 17.5522 11.9023 17.5522ZM11.9023 20.3935H25.0212C25.2093 20.3935 25.3608 20.5457 25.3608 20.7331C25.3608 20.9206 25.2093 21.0727 25.0212 21.0727H11.9023C11.7148 21.0727 11.5626 20.9206 11.5626 20.7331C11.5626 20.5457 11.7148 20.3935 11.9023 20.3935Z"
                  fill="#FFC628"
                />
                <path
                  d="M28.1406 15.1699V20.7024L32.1169 17.5432L28.1406 15.1699Z"
                  fill="#FFC628"
                />
                <path
                  d="M8.76224 15.168L4.7832 17.5433L8.76224 20.7038V15.168Z"
                  fill="#FFC628"
                />
                <path
                  d="M28.0108 21.6983L26.2379 23.0819L22.7656 25.841L31.1224 33.4716H31.392C31.9334 33.4716 32.3742 33.0308 32.3742 32.4894V18.209L28.025 21.6813C28.0189 21.686 28.0169 21.6935 28.0108 21.6983Z"
                  fill="#FFC628"
                />
                <path
                  d="M10.3947 22.8679L8.89489 21.6976C8.89281 21.6955 8.89149 21.6928 8.88945 21.6908L4.52734 18.209V32.4888C4.52734 33.0301 4.96816 33.4709 5.50952 33.4709H5.81179L14.1549 25.8553L10.3947 22.8679Z"
                  fill="#FFC628"
                />
                <path
                  d="M32.3499 3.62863C31.8018 3.08116 31.0444 2.81762 30.2721 2.92969C29.3266 3.05875 28.5489 3.72645 28.2649 4.60878C28.2242 4.73444 28.1943 4.86486 28.1746 4.99935C28.1474 5.13519 28.1406 5.25339 28.1406 5.37089V7.06153H33.0733V5.37089C33.0733 4.71407 32.8165 4.09528 32.3499 3.62863Z"
                  fill="#FFC628"
                />
                <path
                  d="M19.4836 28.4466C19.2506 28.6313 18.9823 28.7448 18.7052 28.7876C18.6223 28.8046 18.5387 28.8134 18.4552 28.8134C18.3717 28.8134 18.2881 28.8052 18.2053 28.7889C17.9247 28.7468 17.6523 28.6341 17.416 28.4466L14.6929 26.2825L6.81836 33.4703H30.1131L22.2257 26.2676L19.4836 28.4466Z"
                  fill="#FFC628"
                />
              </svg>
            </span>
          </p>
        </div>
        <div className="w-[323px] sm:w-[412px] mb-[9px] sm:mb-[19px]">
          <p className="text-white font-manrope text-sm sm:text-xl not-italic font-light leading-normal">
            Get to know candidates in a more personal way—watch their videos to
            see their energy, hear their passion, and understand their approach.
          </p>
        </div>
        <button
          onClick={toSignUp}
          className="flex justify-center items-center gap-[5.485px] sm:gap-[7px] px-[26.4px] py-[9.2px] sm:px-[33.8px] sm:py-[11.74px] rounded-[3.45px] sm:rounded-[4.403px] bg-white text-[#001A55] font-manrope text-[12.537px] sm:text-base not-italic font-normal leading-normal mb-[44px]"
        >
          Get Started for Free!{' '}
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="11"
              viewBox="0 0 28 11"
              fill="none"
            >
              <path
                d="M0.674604 5.21957H25.6648L22.1132 1.66801C21.9257 1.48066 21.9257 1.1766 22.1132 0.989258C22.3007 0.801758 22.6045 0.801758 22.792 0.989258L27.1107 5.30797C27.2336 5.39488 27.3145 5.5375 27.3145 5.69957C27.3145 5.70203 27.3138 5.70431 27.3137 5.70677C27.3138 5.71203 27.3123 5.71699 27.3122 5.72224C27.3099 5.76918 27.3008 5.81396 27.2861 5.85642C27.2774 5.88338 27.265 5.90769 27.2514 5.93308C27.2393 5.95464 27.2259 5.97505 27.2107 5.99441C27.1972 6.0124 27.1902 6.03351 27.1738 6.04988L22.7602 10.4635C22.6665 10.5572 22.5437 10.6041 22.4209 10.6041C22.298 10.6041 22.1752 10.5572 22.0815 10.4635C21.894 10.276 21.894 9.97222 22.0815 9.78472L25.6866 6.17957H0.674604C0.409607 6.17957 0.194605 5.96472 0.194605 5.69957C0.194605 5.43441 0.409607 5.21957 0.674604 5.21957Z"
                fill="#001A55"
              />
            </svg>
          </span>
        </button>
      </div>
      <div className="relative w-[386.931px] h-[318.649px] sm:w-[560.684px] sm:h-[461.74px]">
        {/* <div className="absolute left-[-260px] top-[190px] w-[516.208px] h-[83.346px] rounded-[516.208px] rotate-90 bg-[#001139]"></div> */}

        <div className="flex w-full h-full">
          <img
            src={clientImg}
            alt="client image"
            className="w-full h-full object-cover"
          />
        </div>

        {/* <div className="absolute right-[-50px] top-0 w-[516.208px] h-[83.346px] rounded-[516.208px] rotate-90 bg-red-100"></div> */}
      </div>
    </div>
  )
}

export default Client
